var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A4260B",
    d: "M31.584 23.436c-1.863 0-3.373 1.518-3.373 3.391v27.126c0 1.873 1.51 3.39 3.373 3.39h29.41L67 63.279V26.827c0-1.873-1.51-3.39-3.373-3.39H31.584zm15.122 10.547h1.798l4.39 12.89h-1.762l-1.21-3.707h-4.598l-1.228 3.706h-1.78l4.39-12.89zm.9 1.171h-.034l-.178.787c-.081.343-.179.732-.267 1.022l-1.285 4.05h3.526l-1.301-4.05-.103-.36c-.176-.645-.359-1.449-.359-1.449z",
    transform: "translate(-1035 -1258) translate(0 47) translate(246 1148.313) translate(370 41) translate(419 21.687)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    d: "M37.614 0c2.597 0 4.702 2.099 4.702 4.687v29.296c0 2.588-2.105 4.687-4.702 4.687H8.373L0 46.872V4.687C0 2.1 2.105 0 4.702 0h32.912zm-16.89 10.455c-5.035 0-8.936 3.863-8.936 8.883 0 5.07 3.9 9.08 8.936 9.08 2.123 0 4.024-.664 5.53-1.87l2.024 2.018 1.431-1.525-2.073-1.969c1.259-1.526 2.049-3.543 2.049-5.734 0-5.02-3.9-8.883-8.96-8.883zm0 2.215c3.629 0 6.443 2.83 6.443 6.668 0 1.526-.494 2.978-1.284 4.06l-2-2.017-1.43 1.526L24.5 24.9c-1.012.812-2.469 1.28-3.777 1.28-3.604 0-6.418-2.954-6.418-6.842 0-3.838 2.814-6.668 6.418-6.668z",
    transform: "translate(-1035 -1258) translate(0 47) translate(246 1148.313) translate(370 41) translate(419 21.687)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.5f98a332.svg";
export { ForwardRef as ReactComponent };